var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('iframe',{attrs:{"frameBorder":"0","width":"600","src":"https://lottie.host/?file=3d162b00-0ae0-4997-b89e-8fa20ffb162f/mQHJgdta0j.json"}}),_c('h1',[_vm._v("Campaign created successfully")]),_c('div',[_vm._v("Your campaign has successfully been created and is now running")])])
}]

export { render, staticRenderFns }